export default {"src":"/_next/static/media/Sleep Disorders.931e865b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};